import React from 'react';
import {contentFor} from '../shared/public-search-content.mjs';
import './public-search-content.css';
export default function PublicSearchContent({slug,home=false}){
  const content=contentFor(slug);
  if(!content)return null;
  return <section className={home?'container platform-section public-search-content':'public-search-content'} aria-labelledby={'search-content-'+slug}>
    <h2 id={'search-content-'+slug}>{content.heading}</h2><p>{content.intro}</p>
    {content.items.map((item,index)=><section className="search-answer" key={item.question} id={'business-question-'+index}>
      <h3>{item.question}</h3><p>{item.answer}</p>
      {item.links.length>0&&<p className="search-answer-links">{item.links.map(link=><a key={link.href} href={link.href}>{link.label}</a>)}</p>}
    </section>)}
  </section>;
}
